import { Loading } from '@/components/Loading';
import { Box } from '@/components/lib/components/Box';
import { EmptyFeed } from '@/feature/social-feed/components/EmptyFeed';
import { SocialFeedCardsRow } from '@/feature/social-feed/components/SocialFeedCardsRow';
import { useSocialFeedAndEventsData } from '@/feature/social-feed/use-social-feed';

export const PlayerProfileLineups = ({ playerId }: { playerId: string }) => {
    const { data: socialFeedEntries, fetching: fetchingSocialFeed } = useSocialFeedAndEventsData({
        enabled: true,
        playerId,
    });

    if (fetchingSocialFeed) {
        return (
            <Box justifyContent={'center'} flex={1}>
                <Loading />
            </Box>
        );
    }

    if (socialFeedEntries.length === 0) {
        return <EmptyFeed flex={1} px={'s16'} message="There are currently no lineups for this player." />;
    }

    return (
        <Box pb={'s40'} gap={'s16'}>
            {socialFeedEntries.map((item, index) => (
                <SocialFeedCardsRow
                    key={`${item.socialFeedEntryId}-${index}`}
                    index={index}
                    items={socialFeedEntries}
                    disableMaxWidth
                />
            ))}
        </Box>
    );
};
